<template>
    <div class="loading-root">
        <div :class="{'loading-root-content':isGlobal,'loading-locality-content':!isGlobal}">
            <PtIcon icon="SolidLoadingBars" :style="`fontSize: ${size}px`" />
        </div>
    </div>
</template>

<script>
import { Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

/* eslint-disable */
  export default {
    name: '',
    props: {
        size: {
            type: Number,
            default: 48
            },
        isGlobal:{
            type: Boolean,
            default: true,
        }
    },
    components: {
        PtIcon: Icon
    }
  };
</script>

<style lang="scss" scoped>
.loading-root {
    width: 100%;
    height: 100%;
    .loading-root-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        -ms-transform: translateY(-50%) translateX(-50%);
    }
    .loading-locality-content{
        margin-top: 16px;
        text-align: center;
    }
}


</style>
